export const APP_NAME = 'selectVehicle';
